import { injectable } from "inversify";

import * as Api from "../Constants/ApiUrlConstants";
import { PROVIDERS_REGISTRATION } from "../Constants/IocConstants";
import { IImportBaseService, ImportBaseService } from "./ImportBaseService";

export interface IImportClientiService extends IImportBaseService {

}

@injectable()
export class ImportClientiService extends ImportBaseService implements IImportClientiService {

    UploadUrl = Api.ImportClienti

    constructor() {
        super()
    }

    getProviderName(): string {
        return PROVIDERS_REGISTRATION.IMPORTCLIENTI;
    }
}